<template>
    <div class="modal-container">
        <div class="modal-background"></div>

        <div 
            class="modal-content"
            :class="[
                props.modalContent === 'cookies' && 'light-sand',
                props.modalContent === 'form' && 'light-sand',
                props.modalContent === 'newsletter' && 'newsletter-modal dark-blue',
                props.modalContent === 'upcoming-events' && 'event-modal',
            ]"
        >
            <button v-if="props.modalContent !== 'cookies'" @click="closeModal('showEventConsent')" class="button cta--icon border-0">g</button>

            <div v-if="modalContent === 'cookies'" class="lang-menu-container">
                <langMenu />
            </div>

            <div class="modal-inner">
                <div v-if="modalContent === 'cookies'" class="cookie-container">
                    <div
                        class="cookie-text"
                        v-html="globals.pagecontent.cookieDescription"
                    ></div>

                    <div class="cookie-control">
                        <div class="round-checkbox">
                            <input
                                type="checkbox"
                                id="essential-cookies-checkbox"
                                v-model="essentialCookies"
                                :disabled="true"
                                checked="true"
                            />

                            <label for="essential-cookies-checkbox">
                                {{ globals.pagecontent?.cookieNecessary }}
                            </label>
                        </div>

                        <div class="round-checkbox">
                            <input
                                type="checkbox"
                                id="functional-cookies-checkbox"
                                :checked="functionalCheck === 'true'"
                                v-model="functionalCookies"
                            />

                            <label for="functional-cookies-checkbox">
                                {{ globals.pagecontent?.cookieFunctional }}
                            </label>
                        </div>

                        <div class="round-checkbox">
                            <input
                                type="checkbox"
                                id="analytics-cookies-checkbox"
                                :checked="analyticsCheck === 'true'"
                                v-model="analyticsCookies"
                            />

                            <label for="analytics-cookies-checkbox">
                                {{ globals.pagecontent?.cookieAnalytics }}
                            </label>
                        </div>
                    </div>

                    <div class="cookie-buttons">
                        <button
                            @click="
                                closeModal();
                                cookie.acceptCookies(true);
                                sendCookieData();
                            "
                            class="button button-bordered cta-pill accept"
                        >
                            {{ globals.pagecontent?.cookieAcceptAll }}
                        </button>

                        <button
                            @click="
                                closeModal();
                                cookie.acceptCookies();
                                sendCookieData();
                            "
                            class="button button-bordered cta-pill accept"
                        >
                            {{ globals.pagecontent?.cookieAcceptSelected }}
                        </button>

                        <button 
                            @click="cookie.resetCookies()" 
                            class="button button-bordered cta-pill"
                        >
                            {{ globals.pagecontent?.cookieReset }}
                        </button>
                    </div>
                </div>

                <div v-if="modalContent === 'form'" class="modal-form">
                    <h2>{{ globals.pagecontent.contactFormHeadline }}</h2>

                    <FormModule :givenFormID="1" />
                </div>

                <div v-if="modalContent === 'newsletter'" class="newsletter-container">
                    <iframe src="https://taccd1583.emailsys1a.net/215/2854/ca6bcfee26/subscribe/form.html?_g=1738678290%22" frameborder="0"></iframe>
                </div>

                <div v-if="modalContent === 'upcoming-events'" class="upcoming-event-container">
                    <NuxtLink
                        v-if="globals.pagecontent.upcoming_event_link"
                        :to="globals.pagecontent.upcoming_event_link"
                        :target="globals.pagecontent.upcoming_event_link.includes('walbert-schmitz.de') ? '_self' : '_blank'"
                    >
                        <img :src="globals.pagecontent.upcoming_event_image[0].path" alt="">
                    </NuxtLink>

                    <img v-else :src="globals.pagecontent.upcoming_event_image[0].path" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useRequestStore } from '@/stores/requests'
    import { CookieHandler } from "@/composables/Classes/CookieHandler"

    const { $iframeMessenger } = useNuxtApp()

    const props = defineProps<{
        modalContent: string
    }>()

    const essentialCookies = ref()
    const functionalCookies = ref()
    const analyticsCookies = ref()

    const requestStore = useRequestStore()
    const { globals } = storeToRefs(requestStore)

    const closeModal = (cookiename: string) => {
        useEvent('toggleModal', {open: false})

        if (cookiename) {
            cookie.setCookie(cookiename, 'false', globals.value.pagecontent.event_cookie_lifespan)
        }
    }

    const sendCookieData = () => {
        if (functionalCookies.value !== undefined) {
            $iframeMessenger.post('wallpaper-iframe', 'cookies', { 
                functionalCookies: functionalCookies.value
            });
        }
    }

    const cookie = new CookieHandler(requestStore)

    const analyticsCheck = ref(cookie.getCookie("analyticsCookies"));
    const functionalCheck = ref(cookie.getCookie("functionalCookies"));
</script>